'use strict';
"use es6";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AnonymousSubject = exports.Subject = exports.SubjectSubscriber = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Observable2 = require('./Observable');

var _Subscriber2 = require('./Subscriber');

var _Subscription = require('./Subscription');

var _ObjectUnsubscribedError = require('./util/ObjectUnsubscribedError');

var _SubjectSubscription = require('./SubjectSubscription');

var _rxSubscriber = require('./symbol/rxSubscriber');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class SubjectSubscriber<T>
 */
var SubjectSubscriber = exports.SubjectSubscriber = function (_Subscriber) {
    _inherits(SubjectSubscriber, _Subscriber);

    function SubjectSubscriber(destination) {
        _classCallCheck(this, SubjectSubscriber);

        var _this = _possibleConstructorReturn(this, (SubjectSubscriber.__proto__ || Object.getPrototypeOf(SubjectSubscriber)).call(this, destination));

        _this.destination = destination;
        return _this;
    }

    return SubjectSubscriber;
}(_Subscriber2.Subscriber);
/**
 * @class Subject<T>
 */


var Subject = exports.Subject = function (_Observable) {
    _inherits(Subject, _Observable);

    function Subject() {
        _classCallCheck(this, Subject);

        var _this2 = _possibleConstructorReturn(this, (Subject.__proto__ || Object.getPrototypeOf(Subject)).call(this));

        _this2.observers = [];
        _this2.closed = false;
        _this2.isStopped = false;
        _this2.hasError = false;
        _this2.thrownError = null;
        return _this2;
    }

    _createClass(Subject, [{
        key: _rxSubscriber.rxSubscriber,
        value: function value() {
            return new SubjectSubscriber(this);
        }
    }, {
        key: 'lift',
        value: function lift(operator) {
            var subject = new AnonymousSubject(this, this);
            subject.operator = operator;
            return subject;
        }
    }, {
        key: 'next',
        value: function next(value) {
            if (this.closed) {
                throw new _ObjectUnsubscribedError.ObjectUnsubscribedError();
            }
            if (!this.isStopped) {
                var observers = this.observers;

                var len = observers.length;
                var copy = observers.slice();
                for (var i = 0; i < len; i++) {
                    copy[i].next(value);
                }
            }
        }
    }, {
        key: 'error',
        value: function error(err) {
            if (this.closed) {
                throw new _ObjectUnsubscribedError.ObjectUnsubscribedError();
            }
            this.hasError = true;
            this.thrownError = err;
            this.isStopped = true;
            var observers = this.observers;

            var len = observers.length;
            var copy = observers.slice();
            for (var i = 0; i < len; i++) {
                copy[i].error(err);
            }
            this.observers.length = 0;
        }
    }, {
        key: 'complete',
        value: function complete() {
            if (this.closed) {
                throw new _ObjectUnsubscribedError.ObjectUnsubscribedError();
            }
            this.isStopped = true;
            var observers = this.observers;

            var len = observers.length;
            var copy = observers.slice();
            for (var i = 0; i < len; i++) {
                copy[i].complete();
            }
            this.observers.length = 0;
        }
    }, {
        key: 'unsubscribe',
        value: function unsubscribe() {
            this.isStopped = true;
            this.closed = true;
            this.observers = null;
        }
    }, {
        key: '_trySubscribe',
        value: function _trySubscribe(subscriber) {
            if (this.closed) {
                throw new _ObjectUnsubscribedError.ObjectUnsubscribedError();
            } else {
                return _get(Subject.prototype.__proto__ || Object.getPrototypeOf(Subject.prototype), '_trySubscribe', this).call(this, subscriber);
            }
        }
    }, {
        key: '_subscribe',
        value: function _subscribe(subscriber) {
            if (this.closed) {
                throw new _ObjectUnsubscribedError.ObjectUnsubscribedError();
            } else if (this.hasError) {
                subscriber.error(this.thrownError);
                return _Subscription.Subscription.EMPTY;
            } else if (this.isStopped) {
                subscriber.complete();
                return _Subscription.Subscription.EMPTY;
            } else {
                this.observers.push(subscriber);
                return new _SubjectSubscription.SubjectSubscription(this, subscriber);
            }
        }
    }, {
        key: 'asObservable',
        value: function asObservable() {
            var observable = new _Observable2.Observable();
            observable.source = this;
            return observable;
        }
    }]);

    return Subject;
}(_Observable2.Observable);

Subject.create = function (destination, source) {
    return new AnonymousSubject(destination, source);
};
/**
 * @class AnonymousSubject<T>
 */

var AnonymousSubject = exports.AnonymousSubject = function (_Subject) {
    _inherits(AnonymousSubject, _Subject);

    function AnonymousSubject(destination, source) {
        _classCallCheck(this, AnonymousSubject);

        var _this3 = _possibleConstructorReturn(this, (AnonymousSubject.__proto__ || Object.getPrototypeOf(AnonymousSubject)).call(this));

        _this3.destination = destination;
        _this3.source = source;
        return _this3;
    }

    _createClass(AnonymousSubject, [{
        key: 'next',
        value: function next(value) {
            var destination = this.destination;

            if (destination && destination.next) {
                destination.next(value);
            }
        }
    }, {
        key: 'error',
        value: function error(err) {
            var destination = this.destination;

            if (destination && destination.error) {
                this.destination.error(err);
            }
        }
    }, {
        key: 'complete',
        value: function complete() {
            var destination = this.destination;

            if (destination && destination.complete) {
                this.destination.complete();
            }
        }
    }, {
        key: '_subscribe',
        value: function _subscribe(subscriber) {
            var source = this.source;

            if (source) {
                return this.source.subscribe(subscriber);
            } else {
                return _Subscription.Subscription.EMPTY;
            }
        }
    }]);

    return AnonymousSubject;
}(Subject);
//# sourceMappingURL=Subject.js.map


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/rxjs/static-5.3/Subject.js
// module id = 206
// module chunks = 0